export const DRR_ORDERS_HINT = 'ДРР по заказам = расход ÷ выручка заказов × 100 %, без поправки на выкуп.';

export interface DrrExplanation {
  drrBasis?: 'product' | 'cabinet' | 'orders';
  drrOrders?: number | null;
  revenueBuyout?: number | null;
  buyoutWindowDays?: number;
  buyoutRate?: number | null;
  buyoutPolicy?: 'returns-reserve';
  buyoutNetRate?: number | null;
  buyoutReserveRate?: number | null;
  spend?: number | null;
  revenue?: number;
  drr?: number | null;
}

export const DRR_HINT = 'ДРР = расход ÷ (выручка заказов × расчётный выкуп) × 100 %. Расчётный выкуп — чистая доля кабинета за 30 дней минус дополнительный запас на возвраты. Это консервативная оценка; исходная доля и запас показаны в «i». Итог считается по суммам. Цвет — по пределу кабинета.';
const number = new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 2 });
export function drrCaption(_value: DrrExplanation): string { return 'ДРР'; }

export function drrHint(value: DrrExplanation): string {
  const adjusted = value.drrBasis === 'product' || value.drrBasis === 'cabinet';
  if (!adjusted) return DRR_ORDERS_HINT + (value.drrBasis === 'orders' ? '\nНет корректной доли выкупа кабинета за 30 дней.' : '');
  if (value.buyoutPolicy === 'returns-reserve') {
    const pc = (x: number | null | undefined) => typeof x === 'number' && Number.isFinite(x) ? number.format(x * 100) : '—';
    return `ДРР = расход ÷ (выручка заказов × расчётный выкуп) × 100 %.\nПосле возвратов ${pc(value.buyoutNetRate)} % − запас ${pc(value.buyoutReserveRate)} п.п. = ${pc(value.buyoutRate)} %. Минимум — 0 %.\nЗапас равен доле возвратов от выкупленной суммы за 30 дней и вычитается дополнительно. Оценка с запасом, не фактический выкуп кампании.`;
  }
  const subject = value.drrBasis === 'product' ? 'товара' : 'кабинета';
  const window = value.buyoutWindowDays ? ` за ${value.buyoutWindowDays} дней` : '';
  const rate = typeof value.buyoutRate === 'number' && Number.isFinite(value.buyoutRate) ? `: ${number.format(value.buyoutRate * 100)} %` : '';
  const basis = value.revenueBuyout == null ? '' : `\nБаза после выкупа: ${number.format(value.revenueBuyout)} ₽.`;
  const orders = drrOrderComparison(value);
  const zero = value.revenueBuyout === 0 && (value.spend ?? 0) > 0 ? '\nРасход есть, выручки нет — ДРР ∞.' : '';
  return `ДРР = расход ÷ (выручка заказов × выкуп) × 100 %.\nВыкуп ${subject}${window}${rate}. Единый коэффициент для кампаний и их строк.${basis}${orders ? `\nБез поправки: ${orders}.` : ''}${zero}\nОценка, а не фактический выкуп кампании.`;
}

export function drrBasisLabel(value: DrrExplanation): string {
  return value.buyoutPolicy === 'returns-reserve' ? 'с запасом' : value.drrBasis === 'product' || value.drrBasis === 'cabinet' ? 'оценка выкупа' : 'по заказам';
}
export function drrOrderComparison(value: DrrExplanation): string | null {
  return (value.drrBasis === 'product' || value.drrBasis === 'cabinet') &&
    typeof value.drrOrders === 'number' && Number.isFinite(value.drrOrders)
    ? `${number.format(value.drrOrders)} % по заказам` : null;
}
